export const queryKeys = {
  // Accounts
  allAccounts: 'allAccounts',

  // Events
  allEvents: 'allEvents',
  dashboardEvents: 'dashboardEvents',
  eventAttendance: 'eventAttendance',
  eventMap: 'eventMap',
  optimizedEventRoute: 'optimizedEventRoute',

  // Tasks
  allTasks: 'allTasks',
  dashboardTasks: 'dashboardTasks',

  // Contacts
  allContacts: 'allContacts',

  // Employees
  allEmployees: 'allEmployees',
  employeeUserRoles: 'employeeUserRoles',

  // Employee Time Offs
  allEmployeeTimeOffs: 'allEmployeeTimeOffs',
  employeeTimeOffAvailability: 'employeeTimeOffAvailability',

  // Preferences
  allPreferences: 'allPreferences',

  // Task Templates
  allTaskTemplates: 'allTaskTemplates',

  // Account Templates
  allAccountTemplates: 'allAccountTemplates',

  // Contact Templates
  allContactTemplates: 'allContactTemplates',

  // Employee Templates
  allEmployeeTemplates: 'allEmployeeTemplates',

  // Event Templates
  allEventTemplates: 'allEventTemplates',
  allCustomFields: 'allCustomFields',

  // Email Templates
  allEmailTemplates: 'allEmailTemplates',
  generateEmailPreview: 'generateEmailPreview',
  emailTemplateRecipients: 'emailTemplateRecipients',

  // Form Templates
  allFormTemplates: 'allFormTemplates',

  // Event Form Templates
  allEventFormTemplates: 'allEventFormTemplates',

  // Form Submissions
  allFormSubmissions: 'allFormSubmissions',
  allFormSubmissionPreviews: 'allFormSubmissionPreviews',

  // Email Data
  allEmailData: 'allEmailData',

  // User Permissions
  allUserRoles: 'allUserRoles',
  allActions: 'allActions',
  allPermissions: 'allPermissions',

  // Organization
  currentOrganization: 'currentOrganization',
  currentUser: 'currentUser',
  currentUserSettings: 'currentUserSettings',
  currentUserFilters: 'currentUserFilters',
  organizationIntegrations: 'organizationIntegrations',
  featureFlags: 'featureFlags',

  // Notes
  allNotes: 'allNotes',

  // Attachments
  allAttachments: 'allAttachments',

  // Notifications
  allNotifications: 'allNotifications',

  // Activity Logs
  allActivityLogs: 'allActivityLogs',

  // Billing Tiers
  allBillingTiers: 'allBillingTiers',

  // Dashboard
  dashboardSummary: 'dashboardSummary',

  // Calendar Integrations
  googleCalendars: 'googleCalendars',
  outlookCalendars: 'outlookCalendars',

  // Note Employee Uuids
  noteEmployeeUuids: 'noteEmployeeUuids',

  // Global Search
  globalSearch: 'globalSearch',
};
